import {
  Alert,
  AlertVariantEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  FormField,
  HTMLElementTypeEnum,
  Typography,
} from '@acceso/design-system';

export interface WarningMessageProps {
  title: string;
  description: string;
}

export function WarningMessage({ title, description }: WarningMessageProps) {
  return (
    <FormField>
      <Alert className="w-full" variant={AlertVariantEnum.WARNING}>
        <Typography
          element={HTMLElementTypeEnum.Heading}
          fontSize={FontSizeEnum.Md}
          color={FontColorEnum.Inherit}
          weight={FontWeightEnum.Semibold}
        >
          {title}
        </Typography>

        <Typography
          element={HTMLElementTypeEnum.Paragraph}
          fontSize={FontSizeEnum.Sm}
          color={FontColorEnum.StaticDark}
        >
          {description}
        </Typography>
      </Alert>
    </FormField>
  );
}
